/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/privacy.scss'; 
import { FaShieldAlt, FaFileContract, FaUserCheck, FaEnvelope } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <Nav />

      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="privacy-hero-content">
          <h1>Privacy Policy & Terms</h1>
          <h6>
            <a href="/">Home</a> - Privacy Policy
          </h6>
        </div>
      </section>

      {/* Main Content */}
      <section className="privacy-content">
        <div className="container">
          <div className="privacy-wrapper">
            {/* Left Side - Navigation */}
            {/* <div className="privacy-nav">
              <h3>Quick Links</h3>
              <nav className="policy-links">
                <a href="#privacy-policy" className="policy-link active">
                  <FaShieldAlt /> Privacy Policy
                </a>
                <a href="#terms-conditions" className="policy-link">
                  <FaFileContract /> Terms & Conditions
                </a>
                
              </nav>
              
              <div className="contact-privacy-sidebar">
                <h4>Need Help?</h4>
                <p>Contact our Data Protection Officer</p>
                <a href="mailto:support@artiza.co.ke" className="contact-email">
                  support@artiza.co.ke
                </a>
                <p className="compliance-note">
                  Compliant with Kenya Data Protection Act, 2019
                </p>
              </div>
            </div> */}

            {/* Right Side - Content */}
            <div className="privacy-main">
              {/* Privacy Policy Section */}
              <section id="privacy-policy" className="policy-section">
                <div className="section-header">
                  <h2>Privacy Policy</h2>
                  <p className="section-subtitle">
                    Effective Date: {new Date().toLocaleDateString()}
                  </p>
                </div>

                <div className="policy-content">
                  {/* 1. Introduction */}
                  <div className="policy-article">
                    <h3> Introduction</h3>
                    <p>
                      <strong>Artiza</strong> ("Artiza", "we", "us", or "our") operates a digital marketplace available at 
                      <a className='website-url' href="https://artiza.co.ke"> https://artiza.co.ke</a> (the "Platform"). Artiza connects clients 
                      seeking home improvement, construction, fabrication, and related services with independent 
                      artisans and professionals.
                    </p>
                    <p>
                      This Privacy Policy explains how we collect, use, store, share, and protect personal data of:
                    </p>
                    <ul>
                      <li>Clients</li>
                      <li>Artisans (service providers)</li>
                      <li>Visitors and users of the Platform</li>
                    </ul>
                    <p>
                      This policy is issued in compliance with the Kenya Data Protection Act, 2019 and is subject 
                      to oversight by the Office of the Data Protection Commissioner (ODPC).
                    </p>
                  </div>

                  {/* 2. Categories of Personal Data We Collect */}
                  <div className="policy-article">
                    <h3>Categories of Personal Data We Collect</h3>
                    <p>Depending on how you use the Platform, we may collect:</p>
                    
                    <div className="data-categories">
                      <div className="category-card">
                        <h4>Identity & Contact Information</h4>
                        <ul>
                          <li>Full name</li>
                          <li>Phone number</li>
                          <li>Email address</li>
                          <li>Physical address or service location</li>
                        </ul>
                      </div>

                      <div className="category-card">
                        <h4>Account & Verification Information</h4>
                        <ul>
                          <li>Login credentials</li>
                          <li>Government-issued identification (for artisans)</li>
                          <li>Professional qualifications and certifications</li>
                        </ul>
                      </div>

                      <div className="category-card">
                        <h4>Transaction & Payment Information</h4>
                        <ul>
                          <li>Payment confirmations and transaction references</li>
                          <li>Wallet or payout details (processed via secure third-party payment gateways)</li>
                        </ul>
                      </div>

                      <div className="category-card">
                        <h4>Content & Communications</h4>
                        <ul>
                          <li>Messages exchanged on the Platform</li>
                          <li>Uploaded images, videos, portfolios, and project descriptions</li>
                          <li>Reviews, ratings, and feedback</li>
                        </ul>
                      </div>

                      <div className="category-card">
                        <h4>Technical & Usage Data</h4>
                        <ul>
                          <li>IP address</li>
                          <li>Device and browser information</li>
                          <li>Log data and analytics</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* 3. How We Use Personal Data */}
                  <div className="policy-article">
                    <h3>How We Use Personal Data</h3>
                    <p>Artiza uses personal data to:</p>
                    <div className="usage-grid">
                      <div className="usage-item">Create, manage, and secure user accounts</div>
                      <div className="usage-item">Match clients with suitable artisans</div>
                      <div className="usage-item">Facilitate bookings, payments, and confirmations</div>
                      <div className="usage-item">Enable communication between users</div>
                      <div className="usage-item">Monitor quality, trust, and safety</div>
                      <div className="usage-item">Prevent fraud, abuse, and misuse of the Platform</div>
                      <div className="usage-item">Improve recommendations, analytics, and user experience</div>
                      <div className="usage-item">Send service-related updates and promotional communications (with opt-out options)</div>
                      <div className="usage-item">Comply with legal and regulatory obligations</div>
                    </div>
                  </div>

                  {/* 4. Legal Basis for Processing */}
                  <div className="policy-article">
                    <h3>Legal Basis for Processing</h3>
                    <p>We process personal data on the basis of:</p>
                    <div className="legal-basis">
                      <div className="basis-card">
                        <h4>User Consent</h4>
                        <p>When you explicitly agree to our data practices</p>
                      </div>
                      <div className="basis-card">
                        <h4>Performance of Contract</h4>
                        <p>To fulfill our services to you</p>
                      </div>
                      <div className="basis-card">
                        <h4>Legal Compliance</h4>
                        <p>To meet our legal obligations under Kenyan law</p>
                      </div>
                      <div className="basis-card">
                        <h4>Legitimate Interests</h4>
                        <p>For platform security and quality assurance</p>
                      </div>
                    </div>
                  </div>

                  {/* 5. Data Sharing & Disclosure */}
                  <div className="policy-article">
                    <h3>Data Sharing & Disclosure</h3>
                    <p>We may share personal data with:</p>
                    <ul>
                      <li><strong>Other users</strong> where necessary to complete a service (e.g., client-artisan matching)</li>
                      <li><strong>Payment service providers</strong></li>
                      <li><strong>Technology partners</strong> (hosting, analytics, communications)</li>
                      <li><strong>Legal or regulatory authorities</strong> where required by law</li>
                    </ul>
                    <p className="important-note">
                      <strong>Important:</strong> Artiza does not sell personal data.
                    </p>
                  </div>

                  {/* 6. Messaging & Monitoring */}
                  <div className="policy-article">
                    <h3> Messaging & Monitoring</h3>
                    <p>
                      Communications conducted through the Platform may be stored, reviewed, or monitored for purposes of:
                    </p>
                    <div className="monitoring-reasons">
                      <span className="reason-tag">Fraud prevention</span>
                      <span className="reason-tag">Quality assurance</span>
                      <span className="reason-tag">Dispute resolution</span>
                      <span className="reason-tag">Compliance with Platform policies</span>
                    </div>
                  </div>

                  {/* 7. Data Security */}
                  <div className="policy-article">
                    <h3> Data Security</h3>
                    <p>
                      Artiza implements reasonable technical and organizational safeguards to protect personal data 
                      against unauthorized access, loss, misuse, or disclosure. However, no system can be guaranteed 
                      to be 100% secure.
                    </p>
                  </div>

                  {/* 8. Data Retention */}
                  <div className="policy-article">
                    <h3>Data Retention</h3>
                    <p>
                      Personal data is retained only for as long as necessary to fulfill the purposes outlined in 
                      this policy or as required by applicable law.
                    </p>
                  </div>

                  {/* 9. Your Rights under the Kenya DPA, 2019 */}
                  <div className="policy-article">
                    <h3>Your Rights under the Kenya Data Protection Act, 2019</h3>
                    <p>You have the right to:</p>
                    <div className="rights-grid">
                      <div className="right-item">
                        <h4>Access</h4>
                        <p>Access your personal data</p>
                      </div>
                      <div className="right-item">
                        <h4>Correction</h4>
                        <p>Request correction of inaccurate data</p>
                      </div>
                      <div className="right-item">
                        <h4>Deletion</h4>
                        <p>Request deletion of your data</p>
                      </div>
                      <div className="right-item">
                        <h4>Withdrawal</h4>
                        <p>Withdraw consent</p>
                      </div>
                      <div className="right-item">
                        <h4>Objection</h4>
                        <p>Object to certain processing activities</p>
                      </div>
                      <div className="right-item">
                        <h4>Complaint</h4>
                        <p>Lodge a complaint with the ODPC</p>
                      </div>
                    </div>
                  </div>

                  {/* 10. Contact Information */}
                  <div className="policy-article">
                    <h3> Contact Information</h3>
                    <p>For questions, requests, or complaints:</p>
                    <div className="contact-details">
                      <div className="contact-method">
                        <h4>Email:</h4>
                        <a href="mailto:support@artiza.co.ke">support@artiza.co.ke</a>
                      </div>
                      <div className="contact-method">
                        <h4>Office:</h4>
                        <p>Artiza Ltd, Nairobi, Kenya</p>
                      </div>
                    </div>
                    <div className="compliance-badge">
                      <FaShieldAlt />
                      <span>Compliant with Kenya Data Protection Act, 2019</span>
                    </div>
                  </div>
                </div>
              </section>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;